export const getDataAttributes = props => Object.keys(props).reduce((acc, key) => {
  if (key.startsWith('data-')) {
    acc[key] = props[key];
  }
  return acc;
}, {});
